import { useState, useEffect} from "react";
import './App.css';
import StartMinting from './components/StartMinting';
import InProgressMinting from './components/InProgressMinting';
import CompletedMinting from './components/CompletedMinting';
import bgVideo from './assets/background.mp4'
import nftVideo from './assets/nftvideo.mp4'
import { ethers } from "ethers";
import abi from './contracts/contract.json'

function App() {
  const [contract, setContract] = useState();
  const [supply, setSupply] = useState(0);
  const [account, setAccount] = useState();
  const [hash, setHash] = useState("");
  const [inProgress, setInProgress] = useState(false);
  const [completed, setCompleted] = useState(false);

  const mint = async () => {
    const options = {value: ethers.utils.parseEther("0.001")}
    const transaction = await contract.safeMint(1)//, options)
    setHash(transaction.hash)
    setInProgress(true)
    await transaction.wait();
    setInProgress(false)
    setCompleted(true)
  }

  useEffect(()=> {
    if(contract){
      getTotalSupply();
    }
  },[contract])

  const getTotalSupply = async () =>{
    const totalSupply =  await contract.totalSupply();
    setSupply(totalSupply.toNumber());
  }

  const login = async () => {
    if (typeof window.ethereum !== 'undefined') {
      const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
      const account = accounts[0];
      setAccount(account);
      const contractAddress = '0x58eB10F1d88EbD21AE3CF6eF28dB98dE94Bc0F63';
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer   = provider.getSigner(account);
      const NFTContract = new ethers.Contract(contractAddress, abi, signer);
      setContract(NFTContract);
    }
      
  }

  const getState = () => { 
      if(inProgress){
        return <InProgressMinting hash={hash} />
      }

      if(completed){
        return <CompletedMinting />
      }

      return (
        <StartMinting mint={mint}/>
      )
  }


  return (
    <div className="app">
      <video class="app_bg-video" width="320" heigh="240" autoPlay muted loop>
        <source src={bgVideo} type="video/mp4" />
      </video>
      <div class="card">
        <div class="main">
          <div class="nft-image">
            <video class="nft-video" width="400" heigh="400" autoPlay muted loop>
              <source src={nftVideo} type="video/mp4" />
            </video>
          </div>
          <div class="info">
            <h2>Web3 Builders: Into The MetaVerse</h2>
            <p>{supply}/200 minted</p>
            {
            !account
              ?
              <button onClick={login} class="button">CONNECT WALLET</button>
              :
              getState()
            }
          </div>
        </div>
        <div class="footer">
          MINTING NOW
        </div>
      </div>
    </div>
  );
}

export default App;
